require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-algorithms-implement-insertion-sort.json") })
        }
      }, "path---coding-interview-prep-algorithms-implement-insertion-sort");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-algorithms-implement-insertion-sort!./.cache/json/coding-interview-prep-algorithms-implement-insertion-sort.json
// module id = 1300
// module chunks = 231608221292675